import type { ContentPack } from "@stormglass/game-core";
import { rawLaunchContentPack } from "./definitions.js";
import { validateContentPack } from "./schema.js";

function deepFreeze<T>(value: T): Readonly<T> {
  if (typeof value !== "object" || value === null || Object.isFrozen(value))
    return value;
  Object.freeze(value);
  for (const nested of Object.values(value as Record<string, unknown>))
    deepFreeze(nested);
  return value;
}

export const launchContentPack: ContentPack = deepFreeze(
  validateContentPack(rawLaunchContentPack),
);

export { inspectContentPack, validateContentPack } from "./schema.js";
export type { ContentValidationIssue } from "./schema.js";
